import { FC, memo } from 'react'
import { Link } from '@chakra-ui/react'
import NextLink from 'next/link'

export type NextLinkType = {
  pathname: string
  query: any
}

type Props = any & {
  enableWidth?: boolean
  target?: string
  children: JSX.Element
  href: string | NextLinkType
}

const CustomNextLink: FC<Props> = ({ enableWidth = true, href, children, target = '_self', ...boxProps }) => {
  return (
    <NextLink
      style={enableWidth ? { display: 'block', width: '100%', height: '100%' } : { display: 'block', width: 'auto', height: 'auto' }}
      href={href}
      passHref
      className="accessible"
      target={target}
    >
      <Link as="div" display="block" height="100%" width="100%" className="accessible" tabIndex={-1} _hover={{}} {...boxProps}>
        {children}
      </Link>
    </NextLink>
  )
}

export default memo(CustomNextLink)
